import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { ENV } from '@app/env'
import { TranslateService } from '@ngx-translate/core';
import { AuthProvider } from '../providers/auth/auth';

import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { PatientsPage } from '../pages/patients/patients';
import { AdminUsersPage } from '../pages/admin-users/admin-users';
import { AdminUtilityPage } from '../pages/admin-utility/admin-utility';
import { Observable } from 'rxjs';
import { ProgramDoctorsPage } from '../pages/program-doctors/program-doctors';
import { ProgramClinicsPage } from '../pages/program-clinics/program-clinics';
import { ProgramDocsFilesPage } from '../pages/program-docs-files/program-docs-files';
import { ProgramInsurersPage } from '../pages/program-insurers/program-insurers';
import { ProgramAdverseEventsPage } from '../pages/program-adverse-events/program-adverse-events';
import { ProgramPharmaciesPage } from '../pages/program-pharmacies/program-pharmacies';
import { ProgramBillingPage } from '../pages/program-billing/program-billing';
import { PatientAddEditPage } from '../pages/patient-add-edit/patient-add-edit';
import { PatientUploadPage } from '../pages/patient-upload/patient-upload';
import { ReportPatientDetailsPage } from '../pages/report-patient-details/report-patient-details';
import { ProgramFaxesPage } from '../pages/program-faxes/program-faxes';
import { ReportDispensingPage } from '../pages/report-dispensing/report-dispensing';
import { ProgramKpiPage } from '../pages/program-kpi/program-kpi';
import { ReportEnrolmentsPage } from '../pages/report-enrolments/report-enrolments';
import { ProgramHcpPage } from '../pages/program-hcp/program-hcp';  
import { ProgramPatientStatusPage } from '../pages/program-patient-status/program-patient-status';
import { ProgramFinanceMetricsPage } from '../pages/program-finance-metrics/program-finance-metrics';
import { ReportAdverseEventsPage } from '../pages/report-adverse-events/report-adverse-events';
import { ProgramDocsSecurePage } from '../pages/program-docs-secure/program-docs-secure';
import { ProgramShipmentsPage } from '../pages/program-shipments/program-shipments';
import { ProgramSecureUploadPage } from '../pages/program-secure-upload/program-secure-upload';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage:any = null;

  pages: Array<{icon: string, title: string, component: any, badgecount: number, disabled?: boolean }>;
  adminpages: Array<{icon: string, title: string, component: any, badgecount: number}>;
  testerpages: Array<{icon: string, title: string, component: any, badgecount: number}>; 
  programpages: Array<{icon: string, title: string, component: any, badgecount: number, disabled: boolean}>; 

  versionnumber = ENV.VERSION;
  enrolmentCount: any;

  userlanguage: string = 'en';

  environment: string;
  count$: Observable<number>;

  user: any;

  home_component: any;
  mtpages = { 
    patients_component: PatientsPage,
    patients_upload_component: PatientUploadPage,
    addpatient_component: PatientAddEditPage,
    docsincoming_component: ProgramFaxesPage,
    docsall_component: ProgramDocsFilesPage,
    docssecure_component: ProgramDocsSecurePage,
    ae_component: ProgramAdverseEventsPage,
    m_clinic_component: ProgramClinicsPage,
    m_doctors_component: ProgramDoctorsPage,
    m_insurers_component: ProgramInsurersPage,
    m_pharmacies_component: ProgramPharmaciesPage,
    r_dispensing_component: ReportDispensingPage,
    r_shipping_component: ProgramShipmentsPage,
    r_billing_component: ProgramBillingPage,
    r_patientdetails_componenet: ReportPatientDetailsPage,
    e_adminutility_component: AdminUtilityPage,
    e_systemusers_component: AdminUsersPage,
  }

  program_admin = { 
    detailedpatient: ReportPatientDetailsPage,
    enrolments: ReportEnrolmentsPage,
    status: ProgramPatientStatusPage,
    kpi: ProgramKpiPage,
    copay: ProgramHcpPage,
    definitions: ProgramFinanceMetricsPage,
    ae: ReportAdverseEventsPage
  }

  constructor(
    public platform: Platform, 
    public auth: AuthProvider,
    public translate: TranslateService,
  ) {

    this.initializeApp();
    this.translate.setDefaultLang(this.userlanguage);
  }

  initializeApp() {
    this.environment = ENV.MODE;

    this.auth.getCurrentUser()
      .then(user => { 

        if (user) {
          this.user = user;
          if (this.user.roles.warehouse)  {
            this.home_component = ProgramShipmentsPage;
            this.rootPage = ProgramShipmentsPage; 
          } else if (this.user.roles.secureupload)  {
            this.home_component = HomePage;
            this.rootPage = HomePage;
          } else if (this.user.roles.navigator_super)  {
            this.home_component = PatientsPage;
            this.rootPage = PatientsPage; 
          } else {
            this.home_component = HomePage;
            this.rootPage = HomePage;
          }
        } else {
          this.user = null;
          this.home_component = LoginPage;
          this.rootPage = LoginPage;
        }
    })
  }

  openPageDirect(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page);
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page);
  }

  async signOut() {
    await this.auth.logout();
    await this.nav.setRoot(LoginPage)
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts